import { Outlet } from "react-router-dom";
import { UsersList } from "./users-list";

export function UsersLayout() {
	return (
		<>
			<UsersList />
			<Outlet />
		</>
	);
}
